"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Highlighting = void 0;
var _react = require("react");
var _classNames = require("../../classNames");
var _styles = require("@gogame/ui/styles");
var _getScaleColorIndex = require("../../utils/getScaleColorIndex");
var _constants = require("../../constants");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["withColorScale", "colIndex", "rowIndex"],
  _excluded2 = ["children", "minHeight", "hasRows", "onToggle", "withColorScale"];
var _templateObject;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var cellSelector = ".".concat(_classNames.MUI_CELL);
var rowSelector = ".".concat(_classNames.MUI_ROW);
var StyledComponent = (0, _styles.styled)(function (_ref) {
  var _ = _ref.withColorScale,
    colIndex = _ref.colIndex,
    rowIndex = _ref.rowIndex,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({}, props));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var withColorScale = _ref2.withColorScale,
    theme = _ref2.theme,
    colIndex = _ref2.colIndex,
    rowIndex = _ref2.rowIndex;
  /// .columnsState?.scaled?.length ?
  var highlightedCellSelector = "".concat(cellSelector, "[data-colindex=\"").concat(colIndex, "\"]");
  var highlightedRowSelector = "".concat(rowSelector, "[data-rowindex=\"").concat(rowIndex, "\"]");
  var highlightingStyles = "\n      & ".concat(highlightedRowSelector, " ").concat(cellSelector, ",\n      & ").concat(highlightedCellSelector, " {\n        background: ").concat((0, _styles.blend)(theme.palette.background.paper, theme.palette.action.active, theme.palette.action.hoverOpacity, 1), "; \n      }\n      & .").concat(_classNames.POSITIVE_DIFF, " {\n         color: ").concat(theme.palette.success.main, "; \n         \n      }\n    ");
  var colorScaleCellSelector = "".concat(cellSelector, ":not(.").concat(_classNames.COLLAPSED_CELL, ")");
  var result = highlightingStyles;
  if (withColorScale) {
    result += (0, _getScaleColorIndex.getColorsColumnsClasses)(theme).map(function (_ref3, i) {
      var _ref4 = _slicedToArray(_ref3, 2),
        c = _ref4[0],
        highlightedC = _ref4[1];
      return "\n        & ".concat(colorScaleCellSelector, ".colorScale-").concat(i, " {\n          background-color: ").concat(c, ";\n          &").concat(highlightedCellSelector, ":not(.").concat(_classNames.COLLAPSED_CELL, ") {\n           background-color: ").concat(highlightedC, ";\n          }\n        }\n        \n        & ").concat(highlightedRowSelector, " ").concat(colorScaleCellSelector, ".colorScale-").concat(i, " {\n           background-color: ").concat(highlightedC, ";\n        }\n      ");
    }).join('');
  }
  return result;
});
function getDatasetProp(e, selector, dataSetProp) {
  var target = e.target;
  if (!target.matches(selector)) {
    target = target.closest(selector);
  }
  if (target) {
    return target.dataset[dataSetProp];
  }
}
var Highlighting = exports.Highlighting = function Highlighting(_ref5) {
  var children = _ref5.children,
    minHeight = _ref5.minHeight,
    hasRows = _ref5.hasRows,
    onToggle = _ref5.onToggle,
    withColorScale = _ref5.withColorScale,
    props = _objectWithoutProperties(_ref5, _excluded2);
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    highlightState = _useState2[0],
    setHighlightState = _useState2[1];
  var handleMouseOver = function handleMouseOver(e) {
    var colIndex = getDatasetProp(e, cellSelector, 'colindex');
    var rowIndex = getDatasetProp(e, rowSelector, 'rowindex');
    var changes = {};
    if (colIndex !== undefined) {
      changes.colIndex = colIndex;
    }
    if (rowIndex !== undefined) {
      changes.rowIndex = rowIndex;
    }
    setHighlightState(function (p) {
      return _objectSpread(_objectSpread({}, p), changes);
    });
  };
  var handleMouseLeave = function handleMouseLeave() {
    setHighlightState({});
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledComponent, _objectSpread(_objectSpread({
    colIndex: highlightState.colIndex,
    rowIndex: highlightState.rowIndex,
    onMouseOver: handleMouseOver,
    onMouseLeave: handleMouseLeave,
    withColorScale: withColorScale
  }, props), {}, {
    children: children
  }));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Highlighting, _constants.compareProps);